import React, { useState } from "react";
import {
    AppBar,
    Toolbar,
    Box,
    Button,
    Menu,
    MenuItem,
    IconButton,
    Drawer,
    List,
    ListItem,
    ListItemText,
    Container,
    Collapse,
    ListItemButton
} from "@mui/material";
import { useNavigate, Link } from "react-router-dom";
import MenuIcon from '@mui/icons-material/Menu';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

const BusinessAppBar = () => {
    const navigate = useNavigate();
    const [mobileOpen, setMobileOpen] = useState(false);
    const [businessAnchor, setBusinessAnchor] = useState(null);
    const [mobileBusinessOpen, setMobileBusinessOpen] = useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const handleBusinessMenuOpen = (event) => {
        setBusinessAnchor(event.currentTarget);
    };

    const handleBusinessMenuClose = () => {
        setBusinessAnchor(null);
    };

    const navItems = [
        { label: "WHO WE ARE", path: "/who-we-are" },
        { label: "OUR BUSINESSES", path: "/" },
        { label: "CONTACT US", path: "/contact-us" }
    ];

    const mobileMenu = (
        <Box sx={{ textAlign: 'center', backgroundColor: '#1c1c1c', width: '100%' }}>
            <List>
                {navItems.map((item) => {
                    if (item.label === "OUR BUSINESSES") {
                        return (
                            <React.Fragment key={item.label}>
                                <ListItem disablePadding onClick={() => setMobileBusinessOpen(!mobileBusinessOpen)}>
                                    <Box sx={{ width: '100%', padding: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                                        <ListItemText
                                            primary={item.label}
                                            sx={{
                                                color: 'white',
                                                textAlign: 'center',
                                                flex: 'none',
                                                '& .MuiTypography-root': {
                                                    fontWeight: 600,
                                                    fontSize: '13px',
                                                }
                                            }}
                                        />
                                    </Box>
                                </ListItem>
                                <Collapse in={mobileBusinessOpen} timeout="auto" unmountOnExit>
                                    <List component="div" disablePadding sx={{ backgroundColor: '#333' }}>
                                        {[
                                            { label: "Identity", path: "/business-identity" },
                                            { label: "Cloud", path: "/business-cloud" },
                                            { label: "Fintech", path: "/business-fintech" },
                                            { label: "Authentication", path: "/business-authentication" },
                                            { label: "Digital Infrastructure", path: "/business-digital-infrastructure" }
                                        ].map((subItem) => (
                                            <ListItemButton
                                                key={subItem.label}
                                                component={Link}
                                                to={subItem.path}
                                                onClick={handleDrawerToggle}
                                                sx={{
                                                    pl: 4,
                                                    justifyContent: 'center'
                                                }}
                                            >
                                                <ListItemText
                                                    primary={subItem.label}
                                                    sx={{
                                                        textAlign: 'center',
                                                        '& .MuiTypography-root': {
                                                            color: 'rgba(255, 255, 255, 0.7)',
                                                            fontSize: '12px',
                                                            textTransform: 'uppercase',
                                                            fontWeight: 500
                                                        }
                                                    }}
                                                />
                                            </ListItemButton>
                                        ))}
                                    </List>
                                </Collapse>
                            </React.Fragment>
                        );
                    }

                    return (
                        <ListItem key={item.label} disablePadding>
                            <ListItemText
                                primary={item.label}
                                sx={{
                                    color: 'white',
                                    textAlign: 'center',
                                    '& .MuiTypography-root': {
                                        fontWeight: 600,
                                        fontSize: '13px',
                                        padding: '15px',
                                        cursor: 'pointer'
                                    }
                                }}
                                onClick={() => {
                                    navigate(item.path);
                                    handleDrawerToggle();
                                }}
                            />
                        </ListItem>
                    );
                })}
            </List>
        </Box>
    );

    return (
        <AppBar position="fixed" sx={{ backgroundColor: "#000", boxShadow: "none" }}>
            <Container maxWidth="lg">
                <Toolbar disableGutters sx={{ justifyContent: "space-between", minHeight: "80px !important" }}>
                    {/* Logo */}
                    <Box
                        component="div"
                        onClick={() => navigate("/")}
                        sx={{
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center"
                        }}
                    >
                        <img
                            src={require("../assets/nextix/nextix-logo-white-version.png")}
                            alt="next|ix"
                            style={{
                                height: "40px",
                                objectFit: "contain"
                            }}
                        />
                    </Box>

                    {/* Desktop Navigation Links */}
                    <Box sx={{ display: { xs: "none", md: "flex" }, gap: 4 }}>
                        {navItems.map((item) => {
                            if (item.label === "OUR BUSINESSES") {
                                return (
                                    <Box key={item.label}>
                                        <Button
                                            onClick={handleBusinessMenuOpen}
                                            sx={{
                                                color: "white",
                                                fontSize: "0.7rem",
                                                fontWeight: 500,
                                                letterSpacing: "1.5px",
                                                padding: "6px 12px",
                                                "&:hover": {
                                                    backgroundColor: "rgba(255,255,255,0.05)"
                                                }
                                            }}
                                        >
                                            {item.label}
                                        </Button>
                                        <Menu
                                            anchorEl={businessAnchor}
                                            open={Boolean(businessAnchor)}
                                            onClose={handleBusinessMenuClose}
                                            PaperProps={{
                                                sx: {
                                                    backgroundColor: "#000",
                                                    color: "white",
                                                    mt: 1,
                                                    minWidth: "200px"
                                                }
                                            }}
                                        >
                                            <MenuItem component={Link} to="/business-identity" onClick={handleBusinessMenuClose} sx={{ "&:hover": { backgroundColor: "#1a1a1a" } }}>
                                                Identity
                                            </MenuItem>
                                            <MenuItem component={Link} to="/business-cloud" onClick={handleBusinessMenuClose} sx={{ "&:hover": { backgroundColor: "#1a1a1a" } }}>
                                                Cloud
                                            </MenuItem>
                                            <MenuItem component={Link} to="/business-fintech" onClick={handleBusinessMenuClose} sx={{ "&:hover": { backgroundColor: "#1a1a1a" } }}>
                                                Fintech
                                            </MenuItem>
                                            <MenuItem component={Link} to="/business-authentication" onClick={handleBusinessMenuClose} sx={{ "&:hover": { backgroundColor: "#1a1a1a" } }}>
                                                Authentication
                                            </MenuItem>
                                            <MenuItem component={Link} to="/business-digital-infrastructure" onClick={handleBusinessMenuClose} sx={{ "&:hover": { backgroundColor: "#1a1a1a" } }}>
                                                Digital Infrastructure
                                            </MenuItem>
                                        </Menu>
                                    </Box>
                                );
                            }

                            return (
                                <Button
                                    key={item.label}
                                    onClick={() => navigate(item.path)}
                                    sx={{
                                        color: "white",
                                        fontSize: "0.7rem",
                                        fontWeight: 500,
                                        letterSpacing: "1.5px",
                                        padding: "6px 12px",
                                        "&:hover": {
                                            backgroundColor: "rgba(255,255,255,0.05)"
                                        }
                                    }}
                                >
                                    {item.label}
                                </Button>
                            );
                        })}
                    </Box>

                    {/* Mobile Menu Icon */}
                    <IconButton
                        aria-label="open drawer"
                        edge="end"
                        onClick={handleDrawerToggle}
                        sx={{
                            ml: 1,
                            display: { md: "none" },
                            color: "white"
                        }}
                    >
                        <MenuIcon />
                    </IconButton>

                    {/* Mobile Dropdown Menu */}
                    <Collapse in={mobileOpen} timeout="auto" unmountOnExit sx={{ display: { md: 'none' }, position: 'absolute', top: '80px', left: 0, width: '100%' }}>
                        {mobileMenu}
                    </Collapse>

                </Toolbar>
            </Container>
        </AppBar>
    );
};

export default BusinessAppBar;
